"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentSearchManager = exports.MAX_RECENTS_COUNT = exports.RECENT_SEARCH_LOCALSTORAGE_KEY = void 0;
exports.RECENT_SEARCH_LOCALSTORAGE_KEY = 'recent-addrs';
exports.MAX_RECENTS_COUNT = 5;
var storage = localStorage.getItem(exports.RECENT_SEARCH_LOCALSTORAGE_KEY);
exports.RecentSearchManager = {
    recentAddrs: storage ? JSON.parse(storage) : [],
    save: function (data) {
        localStorage.setItem(exports.RECENT_SEARCH_LOCALSTORAGE_KEY, JSON.stringify(data));
    },
    get: function () {
        return this.recentAddrs;
    },
};
